import { render } from "@/components/pages/dataMonitor/DataMonitorMeasureList.html?vue&type=template&id=71379cfe&external"
import script from "@/components/pages/obd/individual/dataMonitor/ObdDataMonitorMeasureList.js?vue&type=script&lang=js&external"
export * from "@/components/pages/obd/individual/dataMonitor/ObdDataMonitorMeasureList.js?vue&type=script&lang=js&external"

import "@/components/pages/dataMonitor/DataMonitorMeasureList.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__